function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 29.3868C21.5799 29.3868 27 23.7974 27 17.0118C27 10.2263 21.5684 4.625 15 4.625C8.4201 4.625 3 10.2263 3 17.0118C3 23.7974 8.4201 29.3868 15 29.3868ZM21.7522 23.6316C20.5005 22.2697 18.1005 21.1447 15 21.1447C11.911 21.1447 9.511 22.2697 8.25933 23.6316C6.67464 21.9145 5.71005 19.5816 5.71005 17.0118C5.71005 11.6947 9.83254 7.4079 15 7.4079C20.156 7.4079 24.3014 11.6947 24.3129 17.0118C24.3129 19.5816 23.3368 21.9145 21.7522 23.6316ZM15 19.2618C17.2392 19.2737 18.9732 17.3079 18.9732 14.7737C18.9732 12.3816 17.2163 10.3684 15 10.3684C12.7837 10.3684 11.0153 12.3816 11.0383 14.7737C11.0383 17.3079 12.7722 19.25 15 19.2618Z",
  fill: "#F5F6F6"
});

var SvgAdmin = function SvgAdmin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdmin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/admin.c567cb88.svg";
export { ForwardRef as ReactComponent };